import React from 'react';

interface TooltipLabelProps {
	children: React.ReactNode;
	height?: number;
}

const TooltipLabel: React.FC<TooltipLabelProps> = ({ children, height = 15 }) => (
	<div
		style={{
			color: '#ffffff',
			fontSize: 12,
			lineHeight: '16px',
			borderRadius: 6,
			height,
		}}
	>
		{children}
	</div>
);

export default TooltipLabel;
